import type { RewardsHubSharedState, RewardsHubTrackSendEvent } from './rewards-hub';
import { trackRewardsHubAmplitude } from './rewards-hub';
import { REWARDS_HUB_AMP_EVENT, REWARDS_MODULE } from './event-names';
import { getEventPropsBuilder } from '@/tracking/amplitude/utils';

type ReferWidgetTrackArgs = {
    sendEvent: RewardsHubTrackSendEvent | undefined;
    sharedState?: RewardsHubSharedState | null;
};

const getReferWidgetViewedProps = getEventPropsBuilder(() => ({
    event: REWARDS_HUB_AMP_EVENT.REFER_WIDGET_VIEWED,
    Module: REWARDS_MODULE.REWARDS_HUB,
    'Banner Type': 'raf',
    'Banner Format': 'module'
}));

const getReferWidgetClickedProps = getEventPropsBuilder(() => ({
    event: REWARDS_HUB_AMP_EVENT.REFER_WIDGET_CLICKED,
    Module: REWARDS_MODULE.REWARDS_HUB,
    'Banner Type': 'raf',
    'Banner Format': 'module'
}));

export const trackReferWidgetViewedToAmplitude = ({ sendEvent, sharedState }: ReferWidgetTrackArgs) => {
    const eventProps = getReferWidgetViewedProps();
    trackRewardsHubAmplitude({
        sendEvent,
        event: eventProps.event,
        sharedState,
        props: eventProps
    });
};

export const trackReferWidgetClickedToAmplitude = ({ sendEvent, sharedState }: ReferWidgetTrackArgs) => {
    const eventProps = getReferWidgetClickedProps();
    trackRewardsHubAmplitude({
        sendEvent,
        event: eventProps.event,
        sharedState,
        props: eventProps
    });
};
